
export const supportCalendarLink: string = 'https://cal.com/aj21495'
